<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        <!--                        {{ $t('message.edit') }} {{ $tc('message.commonParameters', 1) }}-->
                        {{ $t('message.edit') }} {{$t('message.parameter') }}

                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>

                            <b-col sm="12">
                                <b-form-group
                                        id="poids-group"
                                        :label="$t('message.weight')"
                                        label-for="poids"
                                >
                                    <b-form-input
                                            id="poids"
                                            v-model="$v.form.poids.$model"
                                            :state="$v.form.poids.$dirty ? !(errorshasField('poids') || $v.form.poids.$error) : null"
                                            @focus="clearErrorField('poids')"
                                            type="number"
                                            step="0.01"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.poids.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('poids')">
                                        {{ getErrorsField('poids') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="taille-group"
                                        :label="$t('message.height')"
                                        label-for="taille"
                                >
                                    <b-form-input
                                            id="taille"
                                            v-model="$v.form.taille.$model"
                                            :state="$v.form.taille.$dirty ? !(errorshasField('taille') || $v.form.taille.$error) : null"
                                            @focus="clearErrorField('taille')"
                                            type="number"
                                            step="0.01"

                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.taille.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('taille')">
                                        {{ getErrorsField('taille') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12" v-if="form.communable_type == 'Cardiologie'">
                                <b-form-group
                                        id="perimetre_abdominal-group"
                                        :label="$t('message.abdoPerimetre')"
                                        label-for="perimetre_abdominal"
                                >
                                    <b-form-input
                                            id="perimetre_abdominal"
                                            v-model="$v.form.perimetre_abdominal.$model"
                                            :state="$v.form.perimetre_abdominal.$dirty ? !(errorshasField('perimetre_abdominal') || $v.form.perimetre_abdominal.$error) : null"
                                            @focus="clearErrorField('perimetre_abdominal')"
                                            type="number"
                                            step="0.01"

                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.perimetre_abdominal.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('perimetre_abdominal')">
                                        {{ getErrorsField('perimetre_abdominal') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                            <b-col sm="12">

                                <b-form-group
                                        id="temperature-group"
                                        :label="$t('message.temperature')"
                                        label-for="temperature"
                                >
                                    <b-form-input
                                            id="temperature"
                                            v-model="$v.form.temperature.$model"
                                            :state="$v.form.temperature.$dirty ? !(errorshasField('temperature') || $v.form.temperature.$error) : null"
                                            @focus="clearErrorField('temperature')"
                                            type="number"
                                            step="0.01"

                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.temperature.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('temperature')">
                                        {{ getErrorsField('temperature') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>

                        </b-row>

                        <b-row>

                            <b-col sm="12">

                                <b-form-group
                                        id="ta_systolique-group"
                                        :label="$t('message.taSystolique')"
                                        label-for="ta_systolique"
                                >
                                    <b-form-input
                                            id="ta_systolique"
                                            v-model="$v.form.ta_systolique.$model"
                                            :state="$v.form.ta_systolique.$dirty ? !(errorshasField('ta_systolique') || $v.form.ta_systolique.$error) : null"
                                            @focus="clearErrorField('ta_systolique')"
                                            type="number"
                                            step="0.01"

                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.ta_systolique.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('ta_systolique')">
                                        {{ getErrorsField('ta_systolique') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">

                                <b-form-group
                                        id="ta_diastolique-group"
                                        :label="$t('message.taDiastolique')"
                                        label-for="ta_diastolique"
                                >
                                    <b-form-input
                                            id="ta_diastolique"
                                            v-model="$v.form.ta_diastolique.$model"
                                            :state="$v.form.ta_diastolique.$dirty ? !(errorshasField('ta_diastolique') || $v.form.ta_diastolique.$error) : null"
                                            @focus="clearErrorField('ta_diastolique')"
                                            type="number"
                                            step="0.01"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.form.ta_diastolique.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('ta_diastolique')">
                                        {{ getErrorsField('ta_diastolique') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">

                                <b-form-group
                                        id="ta_systolique_d-group"
                                        :label="$t('message.taSystoliqueD')"
                                        label-for="ta_systolique_d"
                                >
                                    <b-form-input
                                            id="ta_systolique_d"
                                            v-model="$v.form.ta_systolique_d.$model"
                                            :state="$v.form.ta_systolique_d.$dirty ? !(errorshasField('ta_systolique_d') || $v.form.ta_systolique_d.$error) : null"
                                            @focus="clearErrorField('ta_systolique_d')"
                                            type="number"
                                            step="0.01"

                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.ta_systolique_d.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('ta_systolique_d')">
                                        {{ getErrorsField('ta_systolique_d') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">

                                <b-form-group
                                        id="ta_diastolique_d-group"
                                        :label="$t('message.taDiastoliqueD')"
                                        label-for="ta_diastolique_d"
                                >
                                    <b-form-input
                                            id="ta_diastolique_d"
                                            v-model="$v.form.ta_diastolique_d.$model"
                                            :state="$v.form.ta_diastolique_d.$dirty ? !(errorshasField('ta_diastolique_d') || $v.form.ta_diastolique_d.$error) : null"
                                            @focus="clearErrorField('ta_diastolique_d')"
                                            type="number"
                                            step="0.01"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.form.ta_diastolique_d.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('ta_diastolique_d')">
                                        {{ getErrorsField('ta_diastolique_d') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col sm="12">
                                <b-form-group
                                        id="frequence_cardiaque-group"
                                        :label="$t('message.heartRate')"
                                        label-for="frequence_cardiaque"
                                >
                                    <b-form-input
                                            id="frequence_cardiaque"
                                            v-model="$v.form.frequence_cardiaque.$model"
                                            :state="$v.form.frequence_cardiaque.$dirty ? !(errorshasField('frequence_cardiaque') || $v.form.frequence_cardiaque.$error) : null"
                                            @focus="clearErrorField('frequence_cardiaque')"
                                            type="number"
                                            step="0.01"

                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.frequence_cardiaque.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('frequence_cardiaque')">
                                        {{ getErrorsField('frequence_cardiaque') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>


                        </b-row>

                        <b-row>

                            <b-col sm="12">

                                <b-form-group
                                        id="frequence_respiratoire-group"
                                        :label="$t('message.respiratoryRate')"
                                        label-for="frequence_respiratoire"
                                >
                                    <b-form-input
                                            id="frequence_respiratoire"
                                            v-model="$v.form.frequence_respiratoire.$model"
                                            :state="$v.form.frequence_respiratoire.$dirty ? !(errorshasField('frequence_respiratoire') || $v.form.frequence_respiratoire.$error) : null"
                                            @focus="clearErrorField('frequence_respiratoire')"
                                            type="number"
                                            step="0.01"

                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.frequence_respiratoire.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('frequence_respiratoire')">
                                        {{ getErrorsField('frequence_respiratoire') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>

                            </b-col>


                            <b-col sm="12">

                                <b-form-group
                                        id="sato2-group"
                                        :label="$t('message.sato2')"
                                        label-for="sato2"
                                >
                                    <b-form-input
                                            id="sato2"
                                            v-model="$v.form.sato2.$model"
                                            :state="$v.form.sato2.$dirty ? !(errorshasField('sato2') || $v.form.sato2.$error) : null"
                                            @focus="clearErrorField('sato2')"
                                            type="number"
                                            step="0.01"
                                    ></b-form-input>
                                    <b-form-invalid-feedback v-if="!$v.form.sato2.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('sato2')">
                                        {{ getErrorsField('sato2') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                        </b-row>

                        <b-row class="justify-content-sm-center" v-if="form.isAuthor || hasAdminRole || form.canUpdate">
                            <b-button type="submit" variant="primary">
                                {{ $t('message.edit') }}
                            </b-button>

                            <!--                            <b-button type="reset" variant="danger">-->
                            <!--                                {{ $t('message.reset') }}-->
                            <!--                            </b-button>-->
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';

    export default {
        name: "EditCommon",

        computed: {
            ...mapGetters(["commonParameter", "generalConsultation", "errors", "hasAdminRole", "hasMedecinControleRole", "hasPraticienRole","hasAssistante"]),

            can: function () {
                if (this.hasAdminRole) {
                    return true;
                } else {
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },

            form: function () {
                return this.commonParameter;
            },

            mConsultation: function () {
                let parameter = this.commonParameter;
                if (typeof parameter.user == 'object') {
                    let user = parameter.user;

                    let nom = user.nom + ((user.prenom != null && user.prenom) ? (' ' + user.prenom) : '');
                    let dossier = parameter.dossier.numero_dossier;

                    let text = nom + ' ( ' + dossier + ' )' + " " + parameter.consultation.date_consultation;
                    return text;
                }
                return "";
            }
        },

        data() {
            return {
                parameter_id: this.$route.params.parameter,
                show: true
            }
        },

        methods: {
            getParameter: function () {
                let args = {
                    parametreCommun: this.parameter_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getCommonParameter', {args, errorMessages});
            },

            onSubmit: function (evt) {
                evt.preventDefault();

                this.$v.$touch();

                if (!this.$v.$invalid) {
                    let args = {
                        parametreCommun: this.parameter_id,
                        // consultation_medecine_generale_id: this.form.consultation.id,
                        poids: this.form.poids,
                        taille: this.form.taille,
                        ta_systolique: this.form.ta_systolique,
                        ta_diastolique: this.form.ta_diastolique,
                        ta_systolique_d: this.form.ta_systolique_d,
                        ta_diastolique_d: this.form.ta_diastolique_d,
                        temperature: this.form.temperature,
                        frequence_cardiaque: this.form.frequence_cardiaque,
                        frequence_respiratoire: this.form.frequence_respiratoire,
                        sato2: this.form.sato2,
                        perimetre_abdominal: this.form.perimetre_abdominal,
                        communable_type: this.form.communable_type,
                        communable_id: this.form.communable_id,
                    };

                    if (!_.isNull(this.form.consultation)) {
                        args['consultation_medecine_generale_id'] = this.form.consultation.id;
                    }

                    let successMessage = this.$i18n.t('message.commonParameterUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateCommonParameter', {args, errorMessages, successMessage})
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function (evt) {
                /*evt.preventDefault();

                // Reset our form values
                this.form.consultation_medecine_generale_id = '';
                this.form.poids = '';
                this.form.taille = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });*/
            },

            getErrorsField(field) {
                if (this.errorshasField(field)) {
                    return this.errors[field][0];
                } else {
                    return '';
                }
            },

            errorshasField(field) {
                return this.errors.hasOwnProperty(field);
            },

            clearErrorField(field) {
                this.$store.dispatch('clearErrorField', {field});
                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                poids: {},
                taille: {},
                ta_systolique: {},
                ta_diastolique: {},
                ta_systolique_d: {},
                ta_diastolique_d: {},
                temperature: {},
                frequence_cardiaque: {},
                frequence_respiratoire: {},
                sato2: {},
                perimetre_abdominal: {},
            },
        },
        mounted() {
            // Retrieve common parameter
            this.getParameter();

            // new SlimSelect({
            //     select: '#single',
            //     placeholder: 'Select a file number or user information',
            //
            // })

        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>